module.exports = __webpack_public_path__ + "static/media/fk.3c219c64.svg";